import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import "jquery-match-height/jquery.matchHeight";


import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

import {animations} from "./animations";

import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import 'flickity-fade';
import 'flickity-fade/flickity-fade.css';



/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});

window.onload = function() {
    document.body.classList.add('is-ready');
};



(function( $ ){
    'use strict';

    setTimeout( () => {

        document.addEventListener("DOMContentLoaded", function() {
            // Define the SVG icon
            const svgIcon = `
        <svg class="dropdown-icon" width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.727921 0.999984L13.4558 13.7279L0.727921 26.4558" stroke="white"/>
        </svg>
    `;

            // Select all menu items that have children
            const menuItems = document.querySelectorAll('.mobile-menu .menu-item-has-children > a');

            menuItems.forEach(item => {
                // Create a container for the menu item and the SVG icon
                const container = document.createElement('span');
                container.classList.add('menu-item-container');
                container.innerHTML = item.outerHTML + svgIcon;

                // Replace the original menu item with the container
                item.replaceWith(container);

                // Add click event listener to the container
                container.addEventListener('click', function() {
                    const submenu = container.nextElementSibling;

                    if (submenu) {
                        submenu.classList.toggle('expanded');
                        container.querySelector('.dropdown-icon').classList.toggle('rotated');
                    }
                });
            });
        });

        document.addEventListener("DOMContentLoaded", function() {
            const masthead = document.querySelector('.masthead');
            const headerSpacer = document.createElement('div');
            const stickyClass = 'sticky';
            const stickyOffset = 600;

            headerSpacer.style.display = 'none'; // Initially hidden

            // Function to handle the sticky header logic
            function handleStickyHeader() {
                const scrolledFromTop = window.scrollY || document.documentElement.scrollTop;
                const mastheadHeight = masthead.offsetHeight;

                if (scrolledFromTop > stickyOffset) {
                    masthead.classList.add(stickyClass);
                    headerSpacer.style.height = `${mastheadHeight}px`;
                    headerSpacer.style.display = 'block';
                    masthead.parentNode.insertBefore(headerSpacer, masthead);
                } else {
                    masthead.classList.remove(stickyClass);
                    headerSpacer.style.display = 'none';
                }
            }

            // Check the sticky header on scroll and on initial load
            window.addEventListener('scroll', handleStickyHeader);
            window.addEventListener('resize', handleStickyHeader);
            handleStickyHeader(); // Initial check
        });


        document.addEventListener("DOMContentLoaded", function() {
            const footer = document.querySelector('footer');
            const backToTop = document.getElementById('backtotop');
            let lastScrollY = window.scrollY;

            // Function to check if the footer is in view
            function isFooterInView() {
                const rect = footer.getBoundingClientRect();
                const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

                return (rect.top <= windowHeight && rect.bottom >= 0);
            }

            // Function to handle scroll events
            function handleScroll() {
                const currentScrollY = window.scrollY;
                const scrollUp = currentScrollY < lastScrollY;
                const notAtTop = currentScrollY > 0;

                if (scrollUp && notAtTop && !isFooterInView()) {
                    backToTop.style.display = 'flex';
                } else {
                    backToTop.style.display = 'none';
                }

                lastScrollY = currentScrollY;
            }

            // Attach event listeners
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleScroll);
            handleScroll(); // Initial check
        });


        document.addEventListener('DOMContentLoaded', function() {
            const hash = window.location.hash;

            if (hash) {

                // let targetId = hash.substring(1); // Remove the '#' character

                let targetId = hash.replace(/\/$/, ''); // Remove trailing slash if it exists
                console.log(targetId);
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });




        $('.mobile-hamburger').on('click', function(){
            $('body').addClass('menu-open');
        })

        $('.mobile-menu .close-icon').on('click', function(){
            $('body').removeClass('menu-open');
        })

        document.addEventListener('DOMContentLoaded', function() {
            const hotspots = document.querySelectorAll('.hotspot');
            const popups = document.querySelectorAll('.popup');

           if(hotspots){
               hotspots.forEach(hotspot => {
                   hotspot.addEventListener('click', function(event) {
                       event.stopPropagation(); // Prevent click from closing the popup immediately
                       const index = this.getAttribute('data-index');
                       const popup = document.querySelector(`.popup[data-index="${index}"]`);
                       closeAllPopups(); // Close any open popups
                       popup.style.display = 'block';
                       popup.classList.add('active-pop');
                   });
               });

           }
            // Close popups when clicking outside
            document.addEventListener('click', function(event) {
                if (!event.target.closest('.popup')) {
                    closeAllPopups();
                }
            });

            // Close popups when clicking the close button (optional)
            function closeAllPopups() {
                popups.forEach(popup => {
                    popup.classList.remove('active-pop');
                    popup.style.display = 'none';
                });
            }
        });


        AOS.init({  duration: 1000});
        animations.init();
        if ($(window).width() <= 767) {

            $('.js-flipper').on('click', function () {
                var dataLink = $(this).attr('data-link');
                $('[data-target="' + dataLink + '"]').addClass('visible');
            })
        }

        $('.close-icon').on('click', function(){
            $('[data-target]').removeClass('visible');
        })

    }, 1 );

    setTimeout( () => {


    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );
/***************
 * After theme scripts
 ***************/

document.addEventListener('DOMContentLoaded', () => {
    // Initialize the single stay slider
    const singleStayElem = document.querySelector('.js-single-stay-slider');
    if (singleStayElem) {
        const flktySingle = new Flickity(singleStayElem, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: true,
            draggable: true,
            pageDots: false,
            fade: true,
            autoPlay: 9000,
        });
        replaceButtonsNew(singleStayElem);
    }

    // Initialize each stay slider
    const staySliders = document.querySelectorAll('.js-stay-slider');
    staySliders.forEach((elem) => {
        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: false,
            draggable: true,
            pageDots: false,
            groupCells: false, // Remove grouping to slide one at a time
            setGallerySize: true // Ensure gallery is sized correctly

        });
        replaceButtonsNew(elem);
    });

    // Initialize each stay slider
    const productSliders = document.querySelectorAll('.js-product-slider');
    productSliders.forEach((elem) => {
        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: true,
            draggable: true,
            autoPlay: 6000,
            pageDots: false,
            groupCells: false, // Remove grouping to slide one at a time
            setGallerySize: true // Ensure gallery is sized correctly

        });
        replaceButtonsNew(elem);
    });


    // Initialize each stay slider
    const testimonialSliders = document.querySelectorAll('.js-testimonial-slider');
    testimonialSliders.forEach((elem) => {
        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: false,
            draggable: true,
            pageDots: true,
            fade: true,
            autoPlay: 9000,
            autoHeight: true
        });
        replaceButtons(elem);
    });


    function replaceButtons(carouselElement) {
        const prevButton = carouselElement.querySelector('.flickity-prev-next-button.previous');
        const nextButton = carouselElement.querySelector('.flickity-prev-next-button.next');
        console.log(carouselElement);
        if (prevButton) {
            prevButton.innerHTML = `
        <svg class="flickity-button-icon" viewBox="0 0 20 20">
          <use xlink:href="#Lineariconsicon-chevron-left"></use>
        </svg>
      `;
        }

        if (nextButton) {
            nextButton.innerHTML = `
        <svg class="flickity-button-icon" viewBox="0 0 20 20">
          <use xlink:href="#Lineariconsicon-chevron-right"></use>
        </svg>
      `;
        }
    }


    function replaceButtonsNew(carouselElement) {
        const prevButton = carouselElement.querySelector('.flickity-prev-next-button.previous');
        const nextButton = carouselElement.querySelector('.flickity-prev-next-button.next');

        if (prevButton) {
            prevButton.innerHTML = `
      <svg width="17" height="31" viewBox="0 0 17 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.143 29.3553L2.00089 15.2131L16.143 1.071" stroke="white" stroke-width="2"/>
        </svg>

      `;
        }

        if (nextButton) {
            nextButton.innerHTML = `
       <svg width="17" height="30" viewBox="0 0 17 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.14213 0.999953L15.2843 15.1421L1.14214 29.2842" stroke="white" stroke-width="2"/>
        </svg>

      `;
        }
    }

});

// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();
